import { objectKeys } from "app/helpers/objects";
import type { ColumnByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/column-by-keys";
import type { SuggestedColumnName } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";
import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";
import { keepOnlyUniqueElements } from "app/pages/sales-intelligence/utils/arrays";

export const processColumnsByKeys = <T extends IPlainObject>(
    filterDto: Partial<T>,
    columnByKeys: ColumnByKeys<T>,
): readonly SuggestedColumnName[] => {
    const keys = objectKeys(filterDto);

    const columns = keys.reduce<SuggestedColumnName[]>((acum, key) => {
        if (!columnByKeys[key]) {
            return acum;
        }

        return [...acum, ...columnByKeys[key]];
    }, []);

    return keepOnlyUniqueElements<SuggestedColumnName>(columns);
};
